import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './UserMenu.css';

const UserMenu: React.FC = () => {
  const { userProfile, logout } = useAuth();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = React.useState(false);

  const getInitials = () => {
    if (!userProfile) return '?';
    return `${userProfile.firstName.charAt(0)}${userProfile.lastName.charAt(0)}`.toUpperCase();
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  return (
    <div className="user-menu-bar">
      <button className="icon-button help-button" title="Help" onClick={() => navigate('/faq')}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
      </button>
      
      <div className="user-menu-container">
        <button 
          className="user-avatar" 
          onClick={() => setShowMenu(!showMenu)}
          title={userProfile ? `${userProfile.firstName} ${userProfile.lastName}` : 'User'}
        >
          {getInitials()}
        </button>
        
        {showMenu && (
          <>
            <div className="menu-overlay" onClick={() => setShowMenu(false)}></div>
            <div className="user-dropdown">
              <div className="dropdown-header">
                <div className="dropdown-user-info">
                  <div className="dropdown-avatar">{getInitials()}</div>
                  <div className="dropdown-text">
                    <div className="dropdown-name">
                      {userProfile?.firstName} {userProfile?.lastName}
                    </div>
                    <div className="dropdown-email">{userProfile?.email}</div>
                    {userProfile?.nmls && (
                      <div className="dropdown-nmls">NMLS# {userProfile.nmls}</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="dropdown-divider"></div>
              <div className="dropdown-menu">
                <button onClick={() => { navigate('/admin-settings'); setShowMenu(false); }} className="dropdown-item">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="3"></circle>
                    <path d="M12 1v6m0 6v6m5.196-14.196l-4.243 4.243m0 5.657l-4.242 4.242m12.485 0l-4.243-4.242m0-5.657l-4.242-4.243"></path>
                  </svg>
                  Settings
                </button>
                <button onClick={handleLogout} className="dropdown-item logout">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                    <polyline points="16 17 21 12 16 7"></polyline>
                    <line x1="21" y1="12" x2="9" y2="12"></line>
                  </svg>
                  Logout
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UserMenu;
